import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { HowWeWorkPage } from './pages/HowWeWorkPage';
import { OurProcessPage } from './pages/OurProcessPage';
import { WhoWeFundPage } from './pages/WhoWeFundPage';
import { EngagePage } from './pages/EngagePage';
import { ChildProtectionPage } from './pages/ChildProtectionPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/how-we-work" element={<HowWeWorkPage data-id="element-6" />} data-id="element-5" />
          <Route path="/our-process" element={<OurProcessPage data-id="element-8" />} data-id="element-7" />
          <Route path="/who-we-fund" element={<WhoWeFundPage data-id="element-10" />} data-id="element-9" />
          <Route path="/engage" element={<EngagePage data-id="element-12" />} data-id="element-11" />
          <Route path="/child-protection" element={<ChildProtectionPage data-id="element-14" />} data-id="element-13" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}